"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
exports.Status = ({ code, children }) => {
    return (react_1.default.createElement(react_router_dom_1.Route, { render: ({ staticContext }) => {
            if (staticContext) {
                staticContext.statusCode = code;
            }
            return children;
        } }));
};
//# sourceMappingURL=Status.js.map